export default "/_next/static/9af26cfc6cc5057eeae6dec14b7da0e1.png";